import { FaPlay } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { APP_ENVIRONMENT, APP_VERSION } from "../../../api-services/Process";
import { SITELINKS } from "../../../app-routes/links";

const FooterAdmin = () => {
  return (
    <>
      <footer className="xl:container xl:mx-auto md:px-6 text-[10px] flex justify-start gap-3 pb-10 text-gray-600">
        <div>
          {APP_ENVIRONMENT} {APP_VERSION}
        </div>
        <div>|</div>
        <Link to={SITELINKS.CONSENT_FORM} className="hover:text-blue-600">
          Personal data charter
        </Link>
        <div>|</div>
        <div>
          TotalEnergies MVIP &copy;
          {new Date().getFullYear() === 2024 ? "" : "2024 - "}{" "}
          {new Date().getFullYear()}
        </div>
      </footer>

      {APP_ENVIRONMENT?.toLocaleLowerCase() !== "production" && (
        <section className="bg-red-500 text-[9px] text-white font-normal fixed w-[300px] right-0 bottom-0">
          <div className="flex gap-2 items-center">
            <div className="bg-red-600 p-2">
              <FaPlay className="text-2xl" />
            </div>
            <p className="text-start">
              This is a test environment - Inspecton / action tracker forms
              submitted through this link will not be treated!
            </p>
          </div>
        </section>
      )}
    </>
  );
};

export default FooterAdmin;
